import arriereBackoffice, {
  BookKind,
  BookSectionUpdateInput,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

export default {
  async getSections(kind: BookKind): Promise<
    Array<{
      region?: null | {
        id: string
        name: string
      }
      title: string
      key: string
      listOrder: number
      defaultValue?: string
      propertiesUsing: string[]
      propertiesAvaliable: string[]
    }>
  > {
    return arriereBackoffice.queries.bookSections({
      __args: { kind },
      key: true,
      title: true,
      defaultValue: true,
      listOrder: true,
      propertiesUsing: true,
      propertiesAvaliable: true,
      region: {
        id: true,
        name: true,
      },
    })
  },

  async getSectionsForRegion(regionId: string, kind: BookKind) {
    return arriereBackoffice.queries.bookSectionsForRegion({
      __args: { regionId, kind },
      bookKind: true,
      key: true,
      title: true,
      defaultValue: true,
      listOrder: true,
    })
  },

  async createSection(title: string, kind: BookKind) {
    return arriereBackoffice.mutations.homeBooks({
      createSection: {
        __args: { title, kind },
        key: true,
        bookKind: true,
        region: {
          id: true,
          name: true,
        },
        title: true,
        listOrder: true,
        defaultValue: true,
        propertiesUsing: true,
        propertiesAvaliable: true,
      },
    })
  },

  async deleteSection(key: string, kind: BookKind) {
    return arriereBackoffice.mutations.homeBooks({
      deleteSection: {
        __args: { key, kind },
      },
    })
  },

  async updateSections(sections: BookSectionUpdateInput[]) {
    return arriereBackoffice.mutations.homeBooks.raw({
      updateSections: {
        __args: { sections },
      },
    })
  },
}
